import { sortMedcenters } from './utils/sortMedcenters';

import type { IDoctor } from '@/entities/doctor/model/types';

export function doctorsListAdapter(list: IDoctor[]): IDoctor[] {
  return list.map(doctor => {
    return {
      ...doctor,
      avatar: ['dev', 'local'].includes(process.env.NEXT_PUBLIC_ENV)
        ? `https://idoctor.kz/${doctor.avatar}`
        : doctor.avatar,
      medcenters: doctor.medcenters.sort(sortMedcenters),
    };
  });
}
